module.exports = __webpack_public_path__ + "static/img/avatar.697ecdd1.png";